import React from 'react'

const UserMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      y="0.5"
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_103_17181)"
      fillOpacity="0.1"
    />
    <g clipPath="url(#clip0_103_17181)">
      <path
        d="M16 16.5C18.2091 16.5 20 14.7091 20 12.5C20 10.2909 18.2091 8.5 16 8.5C13.7909 8.5 12 10.2909 12 12.5C12 14.7091 13.7909 16.5 16 16.5Z"
        fill="#052351"
      />
      <path
        d="M16 17.8328C12.6878 17.8365 10.0037 20.5206 10 23.8328C10 24.201 10.2985 24.4994 10.6667 24.4994H21.3333C21.7015 24.4994 22 24.201 22 23.8328C21.9963 20.5206 19.3122 17.8364 16 17.8328Z"
        fill="#052351"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_103_17181"
        x1="15.7922"
        y1="0.5"
        x2="15.7922"
        y2="32.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
      <clipPath id="clip0_103_17181">
        <rect width="16" height="16" fill="white" transform="translate(8 8.5)" />
      </clipPath>
    </defs>
  </svg>
)

export default UserMenu
